/**
 * Normalize paginated list payloads and extract user-facing error text.
 */

/**
 * Coerce API list responses into `{ items, totalCount, skipped, limit }`.
 * @param {unknown} data
 * @param {number} [fallbackLimit]
 * @returns {{ items: unknown[], totalCount: number, skipped: number, limit: number }}
 */
export function normalizeListResponse(data, fallbackLimit) {
  const lim = fallbackLimit ?? 10;
  if (!data) return { items: [], totalCount: 0, skipped: 0, limit: lim };
  if (Array.isArray(data)) {
    return { items: data, totalCount: data.length, skipped: 0, limit: data.length || lim };
  }
  const items = data.items ?? data.results ?? [];
  const totalCount = data.totalCount ?? data.total ?? items.length;
  const skipped = data.skipped ?? data.skip ?? 0;
  const limit = data.limit ?? lim;
  return { items, totalCount, skipped, limit };
}

/**
 * Best-effort message from axios errors, {@link ApiError}, or plain strings.
 * @param {unknown} err
 * @returns {string}
 */
export function pickErrorMessage(err) {
  if (!err) return 'Something went wrong';
  if (typeof err === 'string') return err;
  if (err.response?.data?.error?.message) return err.response.data.error.message;
  if (err.message) return err.message;
  return 'Something went wrong';
}
